export default __webpack_public_path__ + "static/media/42.26a95e26.svg";